var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28.8H32V32H0V28.8ZM3.2 16H6.4V27.2H3.2V16ZM11.2 16H14.4V27.2H11.2V16ZM17.6 16H20.8V27.2H17.6V16ZM25.6 16H28.8V27.2H25.6V16ZM0 8L16 0L32 8V14.4H0V8ZM16 9.6C16.8837 9.6 17.6 8.88365 17.6 8C17.6 7.11635 16.8837 6.4 16 6.4C15.1163 6.4 14.4 7.11635 14.4 8C14.4 8.88365 15.1163 9.6 16 9.6Z",
    fill: "#7B51F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank1);
export default __webpack_public_path__ + "static/media/bank1.b4de13c308ddc62bd08e6a8cfa12b830.svg";
export { ForwardRef as ReactComponent };